import { defaultReturn, generateDefaultActions, makeWritePayload } from "shared-utility/store/utils/helpers";

// ACTIONS

export const SET_NEW_LINE_ITEM_SELECTIONS = generateDefaultActions("SET_NEW_LINE_ITEM_SELECTIONS");
export const setNewLineItemSelections = payload => makeWritePayload(SET_NEW_LINE_ITEM_SELECTIONS.value, payload);
export const SET_NEW_LINE_ITEMS_SELECTIONS_TO_DEFAULT = generateDefaultActions("SET_NEW_LINE_ITEMS_SELECTIONS_TO_DEFAULT");
export const setNewLineItemsSelectionsToDefault = payload => makeWritePayload(SET_NEW_LINE_ITEMS_SELECTIONS_TO_DEFAULT.value, payload);

export const actionCreators = {
  setNewLineItemSelections,
  setNewLineItemsSelectionsToDefault
};

const generateInitialComparisonCards = () => Array.from([0, 1], () => ({
  name: "",
  selectedField: null
}));

// REDUCER

const initialState = {
  isMultipleProperties: false,
  newLineItemOperator: "addition",
  selectedField: null,
  newLineItemName: "",
  newLineItemType: "value",
  comparisonOperator: "greaterOf",
  singlePropertyComparisonCards: generateInitialComparisonCards(),
  activeCardIndex: null,
  multiplePropertiesValueFields: null,
  multiplePropertiesComparisonFields: null,
  multiPropComparisonSubLineItemNames: ["", ""],
  propertyIdSelected: null,
  comparisonCalculationType: "cumulative"
};

export const lenderReportNewLineItemManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_NEW_LINE_ITEM_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_NEW_LINE_ITEMS_SELECTIONS_TO_DEFAULT.value:
      return defaultReturn({ ...initialState });

    default:
      return state;
  }
};
